import { useParams } from 'react-router-dom';

import { DEFAULT_LOCALE, isLocaleCode, type LocaleCode } from '@sshop/domain';

export function useLocale(): LocaleCode {
  const { locale } = useParams<{ locale: string }>();
  return isLocaleCode(locale) ? locale : DEFAULT_LOCALE;
}
